import { useQuery } from "@tanstack/react-query";
import { scholarshipsApi } from "../../../api/scholarships";
import { SCHOLARSHIPS_KEY } from "../model";

/*
 * Step 6 of the client's flow: once the sponsor grants an award, the
 * scholarship's owner (the sponsor) follows the awardee up. Shared by HEC's and the owner's screens.
 */

// An awardee's progress, as the owner records it; no status yet means granted, not admitted yet. The
// student sees the scholarship granted only once a university admits them.
export const BENEFICIARY_STATUSES = [{ value: "RECEIVED_BY_UNIVERSITY", label: "Admitted by a university", color: "green" }];
export const beneficiaryStatusOf = (value) =>
  BENEFICIARY_STATUSES.find((s) => s.value === value) ?? { value, label: value ? value : "Granted", color: "blue" };

export const beneficiariesKey = (scholarshipId) => [...SCHOLARSHIPS_KEY, "beneficiaries", scholarshipId];

// The awardees whose award stands (approved, or decided earlier in the abroad scholarship records), best HEC rank first
export const useBeneficiaries = (scholarshipId, { enabled = true } = {}) =>
  useQuery({
    queryKey: beneficiariesKey(scholarshipId),
    enabled,
    queryFn: async () => (await scholarshipsApi.get(`staff/scholarships/${scholarshipId}/beneficiaries`)).data,
  });

/*
 * The sponsor's answer: once the DG signs the nominations off, each nominee waits for the sponsor,
 * who grants or refuses them. The owner answers; the HEC Admin can record it with the sponsor's letter.
 */
export const SPONSOR_ANSWERS = [
  { value: "WITH_SPONSOR", label: "Waiting for the partner", color: "yellow" },
  { value: "GRANTED", label: "Granted", color: "green" },
  { value: "REJECTED", label: "Not granted", color: "red" },
];
export const sponsorAnswerOf = (value) => SPONSOR_ANSWERS.find((s) => s.value === value) ?? { value, label: value ?? "—", color: "gray" };

export const nomineesKey = (scholarshipId) => [...SCHOLARSHIPS_KEY, "nominees", scholarshipId];

// The nominees with the sponsor's answers, and (for HEC only) the reserves that can still be sent
export const useNominees = (scholarshipId, { enabled = true } = {}) =>
  useQuery({
    queryKey: nomineesKey(scholarshipId),
    enabled,
    queryFn: async () => (await scholarshipsApi.get(`staff/scholarships/${scholarshipId}/nominees`)).data,
  });

const GENDERS = { MALE: "Male", FEMALE: "Female" };
export const genderOf = (value) => GENDERS[value] ?? "—";
